import { cn } from '@/libs/tw'

import { Typography } from '../typography/typography'

type NumberInputProps = {
	min: number
	max: number
	value: number
	onUpdate: (value: number) => void
}

export const NumberInput = ({ min, max, value, onUpdate }: NumberInputProps) => {
	return (
		<div className="flex items-center gap-8 rounded-32 border border-textColor p-2 md:border-numberInput-accentColor">
			<button
				className={cn(
					'flex h-[34px] w-[34px] items-center justify-center rounded-[100%] border border-primary bg-textColor text-primary',
					'md:bg-numberInput-accentColor md:text-white'
				)}
				data-testid="decrement"
				disabled={value <= min}
				onClick={() => onUpdate(value - 1)}
			>
				-
			</button>
			<Typography style="p" element="span" data-testid="value">
				{value}
			</Typography>
			<button
				className={cn(
					'flex h-[34px] w-[34px] items-center justify-center rounded-[100%] border border-primary bg-textColor text-primary',
					'md:bg-numberInput-accentColor md:text-white'
				)}
				data-testid="increment"
				disabled={value >= max}
				onClick={() => onUpdate(value + 1)}
			>
				+
			</button>
		</div>
	)
}
